import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class PaketovyModulProvider extends BaseApi {
	async filterInit(params: Record<string, any>) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/FilterInit`, params);
	}
}

export const nabidkaTiskDialogUrl = '/Reports/Reports/GetPaketovyModulNabidkaReport';
export const provider = new PaketovyModulProvider(DMS_MODULE, NAME);
